import { useEffect, useState } from 'react';

export function useDebouncedState<T>(value: T, delay: number = 300): T {
  const [debouncedState, setDebouncedState] = useState<T>(value);

  useEffect(() => {
    if (delay <= 0) {
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedState(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return delay <= 0 ? value : debouncedState;
}
